












































































































































































































































































































import { Vue, Component, Watch, Prop } from "vue-property-decorator";
import { isRoot } from "@/plugins/roles";
import { FinalDocument as IFinalDocument } from "@/api/models/final-document";
import { FinalDocumentEdit as IFinalDocumentEdit } from "@/api/models/final-document-edit";
import { AxiosError } from "axios";
import { ErrorResponse as IErrorResponse } from "@/api/models/error-response";
import { ValidationErrorResponse as IValidationErrorResponse } from "@/api/models/validation-error-response";
import { EducationProtocol as IEducationProtocol } from "@/api/models/education-protocol";
import SelectEntity from "@/components/form/SelectEntity.vue";
import CustomDatepicker from "@/components/form/CustomDatepicker.vue";
import { CourseDocumentInfo as ICourseDocumentInfo } from "@/api/models/course-document-info";
import api, { courseApi } from "@/getinfo-api";
import CustomButton from "@/components/form/CustomButton.vue";
import Modal from "@/components/form/Modal.vue";
import CField from "@/components/form/CField.vue";
import DocumentNumberInput from "@/components/form/DocumentNumberInput.vue";
import { nextSequence } from "@/utils/generate-helper";

@Component({
  components: {
    DocumentNumberInput,
    CField,
    Modal,
    CustomButton,
    SelectEntity,
    CustomDatepicker
  }
})
export default class FinalDocumentForm extends Vue {
  @Prop() finalDocument!: IFinalDocument;
  @Prop() list!: boolean;
  reset: boolean = true;
  listenerId!: string;
  resourceId!: string;
  courseId!: string;
  number!: string;
  issuedAt!: Date;
  user!: any;
  internship!: string | undefined;
  graduateWork!: string | undefined;
  status: number = 1;
  registerNumber!: string;
  educationDocument!: string | undefined;
  series: string | undefined;
  originalNumber!: string | undefined;
  originalRegisterNumber!: string | undefined;
  originalIssuedAt!: Date | undefined;
  recipientName: string | undefined;
  recipientMiddleName!: string | undefined;
  recipientLastName!: string | undefined;
  documentNumberToChange!: string | undefined;
  confirmOfLoss: number | undefined = 0;
  confirmOfExchange: number | undefined = 0;
  destructionConfirm: number | undefined = 0;
  protocol!: IEducationProtocol;
  monthAmount: number = 0;
  signedAt!: Date | undefined;
  courseDocumentInfo!: ICourseDocumentInfo;
  gettingMonthAmountFromCourse: boolean = false;
  awaitingDocument: boolean = false;
  assignedQualificationRank!: string | undefined;
  formOfEducation: number | undefined = 1;
  sourceOfFinance: number | undefined = 0;
  educationalRelations: number | undefined = 1;
  originalSeries: string | undefined;
  count!: number;
  scopeOfActivity!: string | undefined;

  data() {
    return {
      assignedQualificationRank: undefined,
      protocol: undefined,
      listenerId: undefined,
      courses: undefined,
      courseId: undefined,
      number: undefined,
      issuedAt: undefined,
      user: undefined,
      internship: undefined,
      graduateWork: undefined,
      registerNumber: undefined,
      educationDocument: undefined,
      series: undefined,
      originalNumber: undefined,
      originalRegisterNumber: undefined,
      originalIssuedAt: undefined,
      recipientName: undefined,
      recipientMiddleName: undefined,
      recipientLastName: undefined,
      documentNumberToChange: undefined,
      signedAt: undefined,
      originalSeries: undefined,
      count: undefined,
      scopeOfActivity: undefined
    };
  }

  returnThisDay() {
    this.issuedAt = new Date();
  }

  clearForm() {
    this.reset = false;
    this.$nextTick(() => (this.reset = true));
  }

  async getProtocol(item: IEducationProtocol) {
    if (!this.finalDocument) {
      const { data } = await api.EducationProtocolApi.get(item.id);
      this.protocol = data;
      this.getCourseDocumentInfo(this.protocol.course.id);
      if (
        this.$store.getters["finalDocuments/LISTENER_FOR_CREATE_DOCUMENT"].id
      ) {
        this.listenerId = this.$store.getters[
          "finalDocuments/LISTENER_FOR_CREATE_DOCUMENT"
        ].id;
      } else if (this.protocol.listeners?.length)
        this.listenerId = this.protocol.listeners[0].id;
    } else {
      this.protocol = this.finalDocument.protocol;
      if (this.finalDocument.listenerId)
        this.listenerId = this.finalDocument.listenerId;
    }
  }

  getCourseDocumentInfo(courseId: string) {
    this.gettingMonthAmountFromCourse = true;
    this.monthAmount = 0;
    api.CourseApi.getDocumentInfo(courseId)
      .then((res: { data: ICourseDocumentInfo }) => {
        if (res.data.validityOfDocument) {
          this.monthAmount = res.data.validityOfDocument;
        } else {
          this.monthAmount = 0;
        }
      })
      .catch(async () => {
        const {
          data
        } = await courseApi.CourseDocumentInfo.getCourseDocumentInfo(courseId);
        if (data.validityOfDocument) {
          this.monthAmount = data.validityOfDocument;
        } else {
          this.monthAmount = 0;
        }
      })
      .finally(() => {
        this.gettingMonthAmountFromCourse = false;
      });
  }

  cancel() {
    if (typeof this.$route.query.protocolId === "string") {
      this.$router.push({
        name: "educationProtocol",
        params: {
          id: this.protocol.id
        }
      });
    } else {
      this.$router.push({
        name: "finalDocumentList"
      });
    }
  }

  get expiration() {
    if (this.issuedAt) {
      let expiration: Date;

      expiration = new Date(this.issuedAt.getTime());
      if (expiration && this.monthAmount !== 0) {
        expiration = new Date(
          expiration.setMonth(expiration.getMonth() + this.monthAmount)
        );
        return expiration;
      } else return undefined;
    } else return undefined;
  }

  get selectedCompany() {
    return this.$store.getters.selectedCompany;
  }

  get root() {
    return isRoot();
  }

  get companyOwner() {
    return this.$store.getters.userIsCompanyOwner;
  }

  get contentManager() {
    return this.$store.getters.roles?.includes("content_manager");
  }

  deleteDocument() {
    api.FinalDocumentApi._delete(this.finalDocument.id)
      .then(() => {
        this.$router.push({
          name: "finalDocumentList"
        });
      })
      .catch((err: AxiosError<IValidationErrorResponse | IErrorResponse>) => {
        this.$store.dispatch("errorException", {
          vm: this,
          error: err.response
        });
      });
  }

  @Watch("finalDocument")
  updateFinalDocument() {
    this.getProp();
    this.series = this.finalDocument.series;
  }

  @Watch("listenerId")
  updateListener() {
    if (
      this.$route.query.protocolId &&
      this.protocol &&
      this.protocol.listeners
    )
      this.count = this.protocol.listeners
        ?.map(el => el.id)
        .indexOf(this.listenerId);
  }

  @Watch("count")
  updateCount() {
    if (this.$route.query.protocolId) {
      let newurl =
        window.location.protocol +
        "//" +
        window.location.host +
        window.location.pathname +
        `?protocolId=${this.protocol.id}&count=${this.count}`;
      window.history.pushState({ path: newurl }, "", newurl);
    }
  }

  getProp() {
    if (this.finalDocument) {
      this.series = this.finalDocument.series;
      this.formOfEducation = this.finalDocument.formOfEducation;
      this.assignedQualificationRank = this.finalDocument.assignedQualificationRank;
      this.sourceOfFinance = this.finalDocument.sourceOfFinance;
      this.educationalRelations = this.finalDocument.educationalRelations;
      this.number = this.finalDocument.number;
      this.issuedAt = this.finalDocument.issuedAt;
      this.internship = this.finalDocument.internship;
      this.graduateWork = this.finalDocument.graduateWork;
      this.status = this.finalDocument.status;
      this.registerNumber = this.finalDocument.registerNumber;
      this.protocol = this.finalDocument.protocol;
      this.originalNumber = this.finalDocument.originalNumber;
      this.originalRegisterNumber = this.finalDocument.originalRegisterNumber;
      this.originalIssuedAt = this.finalDocument.originalIssuedAt;
      this.educationDocument = this.finalDocument.educationDocument;
      this.recipientName = this.finalDocument.recipientName
        ? this.finalDocument.recipientName
        : "";
      this.recipientMiddleName = this.finalDocument.recipientMiddleName;
      this.recipientLastName = this.finalDocument.recipientLastName;
      this.documentNumberToChange = this.finalDocument.documentNumberToChange;
      this.confirmOfLoss = this.finalDocument.confirmOfLoss;
      this.confirmOfExchange = this.finalDocument.confirmOfExchange;
      this.destructionConfirm = this.finalDocument.destructionConfirm;
      this.signedAt = this.finalDocument.signedAt;
      this.originalSeries = this.finalDocument.originalSeries;
      this.scopeOfActivity = this.finalDocument.activityArea;

      if (this.finalDocument.listenerId) {
        this.listenerId = this.finalDocument.listenerId;
      }
      if (this.finalDocument.expiration && this.finalDocument.issuedAt) {
        this.monthAmount = this.monthDiff(
          this.finalDocument.issuedAt,
          this.finalDocument.expiration
        );
      } else {
        this.monthAmount = 0;
      }
    }
  }

  monthDiff(d1: any, d2: any) {
    d1 = new Date(d1);
    d2 = new Date(d2);
    let months;
    months = (d2.getFullYear() - d1.getFullYear()) * 12;
    months -= d1.getMonth();
    months += d2.getMonth();
    return months <= 0 ? 0 : months;
  }

  async createDocument() {
    if (await this.$store.dispatch("validate/CHECK_VALIDATIONS")) return;
    if (this.list) {
      this.$emit("search", {
        resourceId: this.resourceId
      });
    } else if (this.finalDocument) {
      this.awaitingDocument = true;
      let params: IFinalDocumentEdit = {
        number: this.number.trim(),
        issuedAt: this.issuedAt,
        internship: this.internship,
        graduateWork: this.graduateWork,
        status: this.status,
        registerNumber: this.registerNumber.trim(),
        expiration: this.expiration,
        assignedQualificationRank: this.assignedQualificationRank,
        formOfEducation: this.formOfEducation,
        sourceOfFinance: this.sourceOfFinance,
        educationalRelations: this.educationalRelations,
        activityArea: this.scopeOfActivity,
        educationDocument:
          this.status === 0 ? this.educationDocument : undefined,
        series: this.series?.trim(),
        originalNumber: this.status === 0 ? this.originalNumber : undefined,
        originalRegisterNumber:
          this.status === 0 ? this.originalRegisterNumber : undefined,
        originalIssuedAt: this.status === 0 ? this.originalIssuedAt : undefined,
        originalSeries: this.status === 0 ? this.originalSeries : undefined,
        recipientName: this.status === 0 ? this.recipientName : undefined,
        recipientMiddleName:
          this.status === 0 ? this.recipientMiddleName : undefined,
        recipientLastName:
          this.status === 0 ? this.recipientLastName : undefined,
        documentNumberToChange:
          this.status === 0 ? this.documentNumberToChange : undefined,
        confirmOfLoss: this.status === 0 ? this.confirmOfLoss : undefined,
        confirmOfExchange:
          this.status === 0 ? this.confirmOfExchange : undefined,
        destructionConfirm:
          this.status === 0 ? this.destructionConfirm : undefined,
        signedAt: this.signedAt,
        protocolId: this.protocol.id,
        fileIds: this.protocol.files?.map((el: any) => el.id),
        listenerId: this.listenerId
      };
      api.FinalDocumentApi.edit(this.finalDocument.id, params)
        .then(async (res: { data: IFinalDocument }) => {
          await nextSequence();
          await this.$router.push({
            name: "finalDocument",
            params: {
              id: res.data.id
            }
          });
        })
        .catch((err: AxiosError<IValidationErrorResponse | IErrorResponse>) => {
          this.$store.dispatch("errorException", {
            vm: this,
            error: err.response
          });
        })
        .finally(() => {
          this.awaitingDocument = false;
        });
    } else {
      this.awaitingDocument = true;
      let params: IFinalDocumentEdit = {
        protocolId: this.protocol.id,
        listenerId: this.listenerId,
        number: this.number,
        issuedAt: this.issuedAt,
        internship: this.internship,
        graduateWork: this.graduateWork,
        status: this.status,
        registerNumber: this.registerNumber,
        expiration: this.expiration,
        assignedQualificationRank: this.assignedQualificationRank,
        formOfEducation: this.formOfEducation,
        sourceOfFinance: this.sourceOfFinance,
        educationalRelations: this.educationalRelations,
        activityArea: this.scopeOfActivity,
        series: this.series,
        educationDocument:
          this.status === 0 ? this.educationDocument : undefined,
        originalNumber: this.status === 0 ? this.originalNumber : undefined,
        originalRegisterNumber:
          this.status === 0 ? this.originalRegisterNumber : undefined,
        originalIssuedAt: this.status === 0 ? this.originalIssuedAt : undefined,
        recipientName: this.status === 0 ? this.recipientName : undefined,
        originalSeries: this.status === 0 ? this.originalSeries : undefined,
        recipientMiddleName:
          this.status === 0 ? this.recipientMiddleName : undefined,
        recipientLastName:
          this.status === 0 ? this.recipientLastName : undefined,
        documentNumberToChange:
          this.status === 0 ? this.documentNumberToChange : undefined,
        confirmOfLoss: this.status === 0 ? this.confirmOfLoss : undefined,
        confirmOfExchange:
          this.status === 0 ? this.confirmOfExchange : undefined,
        destructionConfirm:
          this.status === 0 ? this.destructionConfirm : undefined,
        signedAt: this.signedAt
      };
      api.FinalDocumentApi.create(params)
        .then(async (res: { data: IFinalDocument }) => {
          await nextSequence();
          if (typeof this.$route.query.protocolId === "string") {
            if (this.count + 1 === this.protocol.listeners?.length) {
              await this.$router.push({
                name: "educationProtocol",
                params: {
                  id: this.protocol.id
                }
              });
              await this.$store.dispatch("successToast", {
                message: `${this.$tc(this.$translate.Successful)}`
              });
            }

            this.count++;
            this.number = !isNaN(+this.number)
              ? (+this.number + 1).toString()
              : this.number;
            if (this.registerNumber)
              this.registerNumber = !isNaN(+this.registerNumber)
                ? (+this.registerNumber + 1).toString()
                : this.registerNumber;
            this.internship = undefined;
            this.scopeOfActivity = undefined;
            this.graduateWork = undefined;
            this.status = 1;
            this.educationDocument = undefined;
            this.originalSeries = undefined;
            this.originalNumber = undefined;
            this.originalRegisterNumber = undefined;
            this.originalIssuedAt = undefined;
            this.recipientName = undefined;
            this.recipientMiddleName = undefined;
            this.recipientLastName = undefined;
            this.documentNumberToChange = undefined;
            this.confirmOfLoss = 0;
            this.confirmOfExchange = 0;
            this.destructionConfirm = 0;
            if (this.protocol.listeners?.length) {
              this.listenerId = this.protocol.listeners[this.count].id;
            }
            await this.$store.dispatch("successToast", {
              message: `${this.$tc(this.$translate.Successful)}`
            });
          } else {
            await this.$router.push({
              name: "finalDocument",
              params: {
                id: res.data.id
              }
            });
          }
        })
        .catch((err: AxiosError<IValidationErrorResponse | IErrorResponse>) => {
          this.$store.dispatch("errorException", {
            vm: this,
            error: err.response
          });
        })
        .finally(() => {
          this.awaitingDocument = false;
        });
    }
  }

  async mounted() {
    if (this.selectedCompany && this.selectedCompany.id) {
      await this.getProp();
      this.series = this.finalDocument.series;
      this.issuedAt = this.finalDocument.issuedAt;
    }
    if (
      !!this.$store.getters["finalDocuments/PROTOCOL_FOR_CREATE_DOCUMENT"] &&
      !!this.$store.getters["finalDocuments/LISTENER_FOR_CREATE_DOCUMENT"]
    ) {
      this.protocol = this.$store.getters[
        "finalDocuments/PROTOCOL_FOR_CREATE_DOCUMENT"
      ];
      this.listenerId = this.$store.getters[
        "finalDocuments/LISTENER_FOR_CREATE_DOCUMENT"
      ];
    }
    if (typeof this.$route.query.protocolId === "string") {
      api.EducationProtocolApi.get(this.$route.query.protocolId).then(
        (res: { data: IEducationProtocol }) => {
          this.protocol = res.data;
          this.getCourseDocumentInfo(this.protocol.course.id);
          this.issuedAt = this.protocol.protocolCreatedAt;
          this.signedAt = this.protocol.protocolCreatedAt;
          this.count = +this.$route.query.count;

          if (this.protocol.listeners?.length)
            this.listenerId = this.protocol.listeners[
              +this.$route.query.count
            ].id;
        }
      );
    }
  }

  beforeDestroy() {
    this.$store.commit("finalDocuments/CLEAR_CREATE_FINAL_DOCUMENT_FROM_STATE");
  }
}
